<template>
  <v-card class="card-border">
    <v-card-text>
      <v-btn
        v-if="$ability.can('Adicionar','Produto Forca')"
        outlined
        color="blue darken-2"
        rounded
        dark
        depressed
        small
        @click="$refs.dialogFormProdutoForca.show(false, {})"
      >
        <v-icon left>mdi-plus-circle</v-icon>Novo Produto
      </v-btn>
      <DialogFormProdutoForca @created="create($event)" ref="dialogFormProdutoForca" />
      <v-form ref="form">
        <v-row align="center">
          <v-col cols="12" sm="12" md="2">
            <SelectFabricante :multiple="false" @onChanged="fabricante = $event" />
          </v-col>
          <v-col cols="12" sm="12" md="2">
            <SelectAtivo @onChanged="itemsSelectAtivo = $event" />
          </v-col>
          <v-col cols="12" sm="12" md="1">
            <v-btn outlined color="blue darken-2" rounded dark depressed small @click="buscar()">
              <v-icon left>mdi-magnify</v-icon>Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import ProdutoForca from "@/services/produtoForca";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Filtro",

  components: {
    SelectFabricante: () => import("@/components/select/SelectFabricante"),
    DialogFormProdutoForca: () => import("./DialogFormProdutoForca"),
    SelectAtivo: () => import("@/components/select/SelectAtivo")
  },

  data() {
    return {
      // fabricante: null,
      itemsSelectAtivo: "",
      produtoForca: new ProdutoForca()
    };
  },

  computed: {
    ...mapGetters("produtoForca", ["getProdutoForca"])
  },

  methods: {
    ...mapActions({
      actionProdutoForca: "produtoForca/actionProdutoForca"
    }),

    async buscar() {
      if (this.$refs.form.validate()) {
        try {
          const produto = await this.produtoForca.getByFabricanteAndAtivo(
            this.fabricante,
            this.itemsSelectAtivo == "Sim" ? true : false
          );
          this.actionProdutoForca(produto);
          return Promise.resolve();
        } catch (error) {
          this.$toast.error("Erro ao efetuar a busca");
          return Promise.reject(error);
        }
      }
    },

    create(produto) {
      if (this.getProdutoForca === null) {
        this.actionProdutoForca([
          {
            id: produto.id,
            anoModelo: produto.anoModelo,
            dataCriacao: produto.dataCriacao,
            especificacao: produto.especificacao,
            empresas: produto.empresas,
            fabricante: produto.fabricante,
            foto: produto.foto,
            ativo: produto.ativo,
            modelo: produto.modelo,
            potencia: produto.potencia,
            tipo: produto.tipo,
            precoRegioes: {
              Norte: produto.precoRegioes["Norte"],
              "Centro-Oeste": produto.precoRegioes["Centro-Oeste"]
            }
          }
        ]);
      } else {
        this.actionProdutoForca(
          this.getProdutoForca.concat(
            ...[
              {
                id: produto.id,
                anoModelo: produto.anoModelo,
                dataCriacao: produto.dataCriacao,
                especificacao: produto.especificacao,
                empresas: produto.empresas,
                fabricante: produto.fabricante,
                foto: produto.foto,
                ativo: produto.ativo,
                modelo: produto.modelo,
                potencia: produto.potencia,
                tipo: produto.tipo,
                precoRegioes: {
                  Norte: produto.precoRegioes["Norte"],
                  "Centro-Oeste": produto.precoRegioes["Centro-Oeste"]
                }
              }
            ]
          )
        );
      }
    }
  }
};
</script>
